// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
// Standalone routes with lazy loading — each route loads its component on demand
import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./component/main-page/main-page.component').then(m => m.MainPageComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./component/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () => import('./component/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'session-expired',
        loadComponent: () => import('./component/session-expired/session-expired.component').then(m => m.SessionExpiredComponent)
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' }
    ]
  },
  {
    path: 'callback',
    loadComponent: () => import('./component/callback/callback.component').then(m => m.CallbackComponent)
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: 'logout',
    loadComponent: () => import('./component/logout/logout.component').then(m => m.LogoutComponent)
  }
];

